/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Amplify, { Auth } from 'aws-amplify';
import awsExports from 'aws-exports'; // 設定情報を読み込みます。

import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import PasswordForm from 'components/molecules/PasswordForm';
import Button from 'components/atoms/Button';
import { useHistory } from 'react-router-dom';
import useToastNotification from 'hooks/useToastNotification';
import { utilityColor } from 'components/styles';
import BodyText from 'components/atoms/BodyText';
import PrimaryButton from 'components/atoms/Button';
import { checkExistEmail } from 'api/checkExistEmail';

// const styles = {
//   canselButton: css({
//     marginRight: '3em auto',
//   }),
//   h1: css({
//     textAlign: 'left',
//     padding: '0 0',
//     fontSize: '0.75em',
//   }),
//   form: css({
//     padding: '0 1.5em',
//   }),
//   standardLogo: css({
//     marginLeft: 'auto',
//     marginRight: 'auto',
//     verticalAlign: 'middle',
//     width: '100px',
//     height: '100px',
//     padding: '8px 12px',
//   }),
// };

Amplify.configure(awsExports); // 設定情報をAmplifyに反映させます。

const SignUpSchema = Yup.object().shape({
  email: Yup.string()
    .required('メールアドレスを入力してください')
    .email('形式がemailではありません。'),
  password: Yup.string()
    .min(6, 'パスワードは6文字以上で入力して下さい')
    .required('パスワードを入力してください'),
  rePassword: Yup.string()
    .required('パスワード(確認)を入力してください')
    .min(6, 'パスワードは6文字以上で入力して下さい')
    .oneOf([Yup.ref('password')], 'パスワードと確認用のパスワードが異なっています'),
});

const SignUpInputForm: React.FC = () => {
  const { successNotification, errorNotification } = useToastNotification();
  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      rePassword: '',
    },
    onSubmit: (values) => {
      Auth.signUp(formik.values.email, formik.values.password)
        .then((data : any) => {
          successNotification(`ユーザー登録が完了しました。`);
          history.push(`/login`);
        })
        .catch((err : any) => {
          if (err.code === 'UsernameExistsException') {
            errorNotification('既にユーザー登録は完了していますので、ユーザ登録する必要はありません');
          } else if (err.message === 'Username should be an email.') {
            errorNotification('正しいメールアドレスを入力して下さい');
          } else if (err.message === "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6") {
            errorNotification('パスワードは6文字以上で入力して下さい');
          } else if (err.code === 'InvalidParameterException') {
            errorNotification('パスワードと確認用のパスワードが異なっています');
          } else {
            errorNotification('ユーザー登録に失敗しました');
          }
        });
    },
    validationSchema: SignUpSchema,
  });

  const handleSubmitSignUp = async () => {

    try {
      checkExistEmail(
        formik.values.email,
      ).then((response: any) => {
        formik.handleSubmit();
      })
      .catch((error: any) => {
        errorNotification('スタッフ情報が登録されていないためユーザー登録できません。');
      });
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
    }
    
  }
  return (
    <form onSubmit={formik.handleSubmit}>
      <FormField>
        <TextForm
          name="email"
          label="メールアドレス"
          placeHolder="メールアドレスを入力"
          value={formik.values.email}
          onChange={formik.handleChange}
          errorMsg={formik.errors.email}
        />
      </FormField>
      <FormField>
        <PasswordForm
          name="password"
          label="パスワード"
          placeHolder="パスワードを入力"
          value={formik.values.password}
          onChange={formik.handleChange}
          errorMsg={formik.errors.password}
        />
      </FormField>

      <FormField displayBlock={true}>
        <BodyText
            size="re"
          >
          パスワード(確認)
        </BodyText>
        <PasswordForm
          name="rePassword"
          label=""
          placeHolder="パスワード（確認）"
          value={formik.values.rePassword}
          onChange={formik.handleChange}
          errorMsg={formik.errors.rePassword}
        />
      </FormField>
      <FormSubmitArea>
        <div css={css({textAlign: 'center', width: '100%', marginTop: '20px'})}>
          <Button
            text="ユーザー登録"
            onClick={() => handleSubmitSignUp()}
            minWidth="160px"
          />
        </div>
        <div css={css({textAlign: 'center', width: '100%'})}>
          <PrimaryButton
            text="キャンセル"
            ghost={true}
            // eslint-disable-next-line no-restricted-globals
            onClick={() => history.replace('/login')}
          />
        </div>
        
      </FormSubmitArea>
    </form>
  );
};

export default SignUpInputForm;
